import React from "react";
import { HashLoader } from 'react-spinners'

export class Loader extends React.Component {
    render() {
        return (
            <div className="loaderDiv" style={{ display: this.props.loading ? 'flex' : 'none' }}>
                <HashLoader
                    cssOverride={{
                        position: "absolute",
                        top: "45%",
                        left: "47%",
                        display: "block",
                        margin: "0 auto",
                        borderColor: "white",
                        zIndex: "1999"
                    }}
                    color={'#8f00ff'}
                    loading={this.props.loading}
                />
            </div>
        );
    }
}



const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function debounceFunc(funcInput, timeoutVal) {
    let timer = timeoutVal | undefined;
    return (...args) => {
        const next = () => { funcInput(...args) }
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(next, timeoutVal > 0 ? timeoutVal : 2000);
    }
};

export function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }

    return [year, month, day].join('-');
};

export function displayDate(date) {
    let splitDate = date.split("-");
    let newDate = `${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`
    return newDate
}

export function getWeekDetails(dateInput = null) {
    // dateInput like: '2025-03-20'
    const date = dateInput ? new Date(dateInput) : new Date();

    // --- ISO WEEK LOGIC ---
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7)); // nearest Thursday
    const year = d.getUTCFullYear();

    const startOfYear = new Date(Date.UTC(year, 0, 1));
    const weekNo = Math.ceil((((d - startOfYear) / 86400000) + 1) / 7);
    const weekId = `${year}-W${String(weekNo).padStart(2, "0")}`;

    // --- WEEK START (Monday) ---
    const weekStart = new Date(d);
    weekStart.setUTCDate(d.getUTCDate() - 3);

    // --- Format Helper ---
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // --- Dates of the Week ---
    let dates = [], formatedDate = [];
    for (let i = 0; i < 7; i++) {
        let day = new Date(weekStart);
        day.setUTCDate(weekStart.getUTCDate() + i);

        const formatted = `${day.getUTCDate()} ${monthNames[day.getUTCMonth()]} ${day.getUTCFullYear()}`;
        dates.push(formatted);
        formatedDate.push(day.toISOString().substring(0, 10));
    }


    return { weekId, dates, formatedDate };
}

// Current week as the padded ISO code 'YYYY-Www'. Delegates to getWeekDetails() so every
// default week in the app agrees with the codes WeekRangeSelect lists and the backend stores.
// (The old inline Math.ceil(days / 7) count was not ISO and ran a week behind.)
export function formatWeek() {
    return getWeekDetails().weekId;
}

export function getISOWeek(w, y) {
    var simple = new Date(y, 0, 1 + (w - 1) * 7);
    var dow = simple.getDay();
    var ISOweekStart = simple;
    if (dow <= 4)
        ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    else
        ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
    const temp = {
        d: ISOweekStart.getDate(),
        m: ISOweekStart.getMonth(),
        y: ISOweekStart.getFullYear(),
    }
    const numDaysInMonth = new Date(temp.y, temp.m + 1, 0).getDate()

    return Array.from({ length: 7 }, _ => {
        if (temp.d > numDaysInMonth) {
            temp.m += 1;
            temp.d = 1;
        }

        let MyDate = new Date(temp.y, temp.m, temp.d++)
        let yyyy = MyDate.getFullYear();
        let mm = MyDate.getMonth(); // Months start at 0!
        let dd = MyDate.getDate();

        // if (dd < 10) dd = '0' + dd;
        // if (mm < 10) mm = '0' + mm;

        let formattedToday = dd + ' ' + monthNames[mm] + ' ' + yyyy;

        return formattedToday
    });
}


export function getWeekNumber(date) {
    const target = new Date(date.valueOf());

    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday (0) into 7
    var ny = new Date(date).getFullYear()
    const dayNr = (date.getDay() + 6) % 7;
    target.setDate(target.getDate() - dayNr + 3);

    // January 4 is always in week 1
    const jan4 = new Date(target.getFullYear(), 0, 4);

    // Calculate full weeks to the nearest Thursday
    const weekNo = 1 + Math.round(((target - jan4) / 86400000 - 3 + ((jan4.getDay() + 6) % 7)) / 7);

    return `${ny}-W${weekNo}`
}


// The 7 day labels ("31 Aug 2026", …) of a 'YYYY-Www' week code, in the shape the weekly
// grids expect. Wraps the split/parse/reverse dance that was copy-pasted into every
// week-change handler, so a preselected week can seed its day rows the same way a manual
// pick does. Returns [] for an empty/malformed code.
export async function getWeekDayList(weekCode) {
    if (!weekCode) return [];
    const [year, week] = String(weekCode).split("-W");
    if (year === undefined || week === undefined) return [];
    return await getISOWeek(parseInt(week, 10), parseInt(year, 10));
}

// 15

// SELECT 
//     *, CONCAT(YEAR(BD_DATE), '-W', WEEKOFYEAR(BD_DATE))
// FROM
// 	pc_week_del_bd WHERE BD_DATE LIKE '%2025-06-02%'
// ORDER BY WD_BD_ID DESC


export function getISOWeekDates(weekString) {
    const [year, week] = weekString.split("-W").map(Number);

    const simple = new Date(year, 0, 1 + (week - 1) * 7);
    const dayOfWeek = simple.getDay();
    const ISOweekStart = new Date(simple);

    if (dayOfWeek <= 4)
        ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    else
        ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());

    const ISOweekEnd = new Date(ISOweekStart);
    ISOweekEnd.setDate(ISOweekStart.getDate() + 6);

    return { start: ISOweekStart, end: ISOweekEnd };
}

/* ── Week code vs DATE window ─────────────────────────────────────
   Pay Account partner / card windows hold DATES since migration
   2026_10_14_partner_card_date_windows.sql, while weekly sales are
   still keyed by week code ('2026-W10'). These two bridge them.

   THE RULE (user's decision, 2026-10-13): a week belongs to a window
   when that week's MONDAY falls inside it. Shares therefore stay
   week-granular — a partner receives the whole week or none of it —
   and converting the stored week codes to Monday..Sunday spans left
   coverage byte-identical (993 partner and 235 card pairs, unchanged).

   This also retires a latent bug. The old code compared weeks as
   parseInt("2026" + "10") = 202610, which breaks the moment a week is
   not zero-padded: '2026-W9' became 20269, LESS than 202610, so a
   window would silently skip weeks. No unpadded codes existed in the
   data, but the format allowed them. ISO date strings compare
   correctly as strings, so the hazard is gone rather than avoided. */
export function weekStartDate(weekCode) {
    if (!weekCode || typeof weekCode !== 'string' || !weekCode.includes('-W')) return '';
    const { start } = getISOWeekDates(weekCode);
    if (!start || isNaN(start.getTime())) return '';
    const y = start.getFullYear();
    const m = String(start.getMonth() + 1).padStart(2, '0');
    const d = String(start.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

/* Is this week inside [fromDate, toDate]? Dates are 'YYYY-MM-DD'.
   Returns false when anything is missing, so a half-entered window
   never silently matches every week. */
export function weekInDateWindow(weekCode, fromDate, toDate) {
    const monday = weekStartDate(weekCode);
    if (!monday || !fromDate || !toDate) return false;
    return monday >= String(fromDate) && monday <= String(toDate);
}

/* Does a partner/card window cover ANY week of a report range?
   Added 2026-10-19 for Account Balance, which was listing one column per
   partner shop with no date filter at all — so a partnership that ended in
   2024 still produced a column in an August 2026 report (86 such rows across
   22 accounts).

   Enumerates the actual weeks and reuses weekInDateWindow, so a shop appears
   as a column EXACTLY when it can contribute a figure to at least one week on
   screen. An overlap test on the range end-points alone is not equivalent: a
   window sitting strictly between two Mondays contains no week start and would
   produce an empty column.

   Fails OPEN on missing input — a half-entered window keeps its column rather
   than vanishing from the setup. */
export function windowCoversAnyWeek(fromDate, toDate, fromWeek, toWeek) {
    if (!fromWeek || !toWeek) return true;
    if (!fromDate || !toDate) return true;

    const first = weekStartDate(fromWeek);
    const last = weekStartDate(toWeek);
    if (!first || !last) return true;

    const d = new Date(first + 'T00:00:00');
    const end = new Date(last + 'T00:00:00');
    if (isNaN(d.getTime()) || isNaN(end.getTime())) return true;

    // Walk Monday by Monday. Bounded by a sane ceiling so a bad range cannot spin.
    for (let guard = 0; d <= end && guard < 1040; guard++) {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const iso = `${y}-${m}-${day}`;
        if (iso >= String(fromDate) && iso <= String(toDate)) return true;
        d.setDate(d.getDate() + 7);
    }
    return false;
}


/* ── Money / numeric helpers ──────────────────────────────────────
   Single source of truth for money maths. JavaScript stores decimals
   in binary, so summing 2-decimal amounts leaks noise into the far
   decimals: 1234.10 + 2727.80 shows as 3961.9000000000005, and
   accumulations land on values like 1755.6999999999998. That noise is
   NOT real money — it's a representation artifact ~13 places out.

   round2()   strips the noise and returns the exact cent value
              (1755.6999999999998 -> 1755.7, 8.20 stays 8.20). This is
              plain 2-decimal rounding, the standard for currency; it
              never loses a cent (unlike truncation, which would turn a
              clean 8.20 into 8.19).
   sumMoney() sums an array with no drift by working in integer cents,
              then converts back — use this for any "sum an array of
              objects" total (reports, sales, accounts, payments, …).
   money()    formats a value as a fixed 2-decimal string for display.
   parseMoney() reads a money value that was STORED as display text
              ("-83,983.68") and would otherwise coerce to NaN. */

// Round a number to 2 decimals, removing binary-float noise. Non-numeric
// or non-finite input becomes 0.
export function round2(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return 0;
    return Math.round((n + Number.EPSILON) * 100) / 100;
}

// Sum an array of money values with zero float drift (adds up integer
// cents, then divides back). `selector` picks the number from each element
// and may be a field name ("Amount"), a function (d => d.a + d.b), or be
// omitted when the array already holds numbers.
export function sumMoney(list, selector) {
    if (!Array.isArray(list)) return 0;
    const pick =
        typeof selector === "function" ? selector
        : selector != null ? (item) => (item == null ? 0 : item[selector])
        : (item) => item;
    const cents = list.reduce((acc, item) => {
        const n = Number(pick(item));
        return acc + (Number.isFinite(n) ? Math.round(n * 100) : 0);
    }, 0);
    return cents / 100;
}

// "3961.90" — a value shown with exactly 2 decimals. Safe for any number
// because it rounds first, so noise never reaches the string.
export function money(value) {
    return round2(value).toFixed(2);
}

// "£ 450.00" for a money GRID cell, or "—" when nothing is stored (2026-10-22). money() alone turns
// a blank into "0.00", and 16,944 of 17,152 shop item records have no sale rate — showing those as
// £ 0.00 would claim a price of zero. A stored 0 still reads "£ 0.00".
export function moneyCell(value) {
    if (value === null || value === undefined || String(value).trim() === "") return "—";
    return `£ ${formatAmount(value)}`;
}

/* ── Amount DISPLAY and amount INPUT (2026-10-22) ────────────────────────
   The user's rule: every amount is SHOWN as 000,000,000.00, and every amount
   field accepts only digits, one leading "-" and one "." (max 2 decimals).

   formatAmount() is DISPLAY ONLY. It must never feed a calculation, a state
   value or a request body — "1,234.50" read back with parseFloat() is 1, and
   PHP's floatval() does the same. That is why money() is left untouched: it
   is what payloads and state use (e.g. WeeklySale posts WS_PRO_LOS:
   money(...)), so stored values never contain a comma. Same rounding as
   money(), so a displayed figure is numerically identical — only the
   thousands separators are new. */
export function formatAmount(value) {
    // `|| 0` turns -0 into 0, so -0.004 reads "0.00" exactly as money() prints it, not "-0.00".
    return (round2(value) || 0).toLocaleString("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

/* Accounting style: a negative amount in brackets — -511.11 reads "(511.11)". DISPLAY ONLY, for
   the reports rebuilt to the legacy layouts (T1.36); like formatAmount, never feed it back into a
   calculation or a payload. */
export function formatAccounting(value) {
    const n = round2(value) || 0;
    return n < 0 ? `(${formatAmount(-n)})` : formatAmount(n);
}

/* What an amount field may hold while it is being typed: one optional leading
   "-", digits, one ".", at most 2 decimals. Everything else is dropped as it is
   typed or pasted (so a pasted "£1,234.5" becomes "1234.5"). Returns a plain
   string — never commas — so handlers and saves receive exactly what they did. */
export function sanitizeAmountInput(raw) {
    const s = String(raw === null || raw === undefined ? "" : raw);
    const negative = s.trim().startsWith("-");
    let digits = s.replace(/[^0-9.]/g, "");
    const dot = digits.indexOf(".");
    if (dot !== -1) {
        digits = digits.slice(0, dot + 1) + digits.slice(dot + 1).replace(/\./g, "").slice(0, 2);
    }
    return (negative ? "-" : "") + digits;
}

/* ── The Profit & Loss render deduction ──────────────────────────────────
   Added 2026-10-13 on the user's instruction: the P&L report shows
   "total profit/loss − 25%".

   DISPLAY ONLY. Nothing is stored and no other report applies it —
   pc_weekly_sale.WS_PRO_LOS keeps the undeducted figure, and Account
   Balance, Shop Summary and Shop Payment are untouched. Apply it where a
   figure is PRINTED, never where one is summed or posted; that is the same
   rule that kept renderTotalAmount() safe during the 2-decimal sweep.

   LITERAL IN BOTH DIRECTIONS, confirmed with the user: a profit of 4,000
   renders as 3,000, and a LOSS of −4,000 renders as −3,000. A loss
   therefore looks 25% smaller. That was the explicit choice over "deduct
   from profit only" — do not quietly change it.

   One fixed rate for every shop, by decision. If it ever needs to vary,
   pc_shop_charges is the precedent: it already stores rent/K&N/NDR per
   shop per week range, so history is not rewritten when a rate changes. */
export const PNL_RENDER_DEDUCTION = 0.25;

// What the report prints: the figure less the deduction.
export function pnlAfterDeduction(value) {
    return round2(round2(value) * (1 - PNL_RENDER_DEDUCTION));
}

// The deduction, DERIVED from the figure above rather than rounded separately.
// Rounding both independently loses a penny on small values (-0.02 would print
// as "less 0.00" and "amount -0.01"), and the three rows on screen have to add
// up — a report whose own arithmetic does not reconcile is worse than useless.
export function pnlDeduction(value) {
    return round2(round2(value) - pnlAfterDeduction(value));
}


// Read a money value that may have been stored as DISPLAY text rather than a
// clean number — thousands separators, a currency symbol, stray whitespace,
// or an accounting-style "(123.45)" for a negative. Several money columns are
// varchar (pc_pay_account.OPENING_BALANCE, pc_acc_trans_cash.TR_AMT, …), so
// what comes back from the API is whatever was typed. Plain `+value` turns
// "-83,983.68" into NaN, which then poisons every total it reaches.
//
// Returns 0 for anything unparseable, matching round2()'s contract. Use this
// at the point a varchar money column is read; round2/sumMoney are left
// strict on purpose, so a bad value elsewhere still surfaces rather than
// being quietly accepted.
export function parseMoney(value) {
    if (typeof value === "number") return Number.isFinite(value) ? value : 0;
    if (value == null) return 0;

    let s = String(value).trim();
    if (s === "") return 0;

    // "(1,234.56)" is a negative in accounting notation.
    const bracketed = /^\((.*)\)$/.exec(s);
    if (bracketed) s = "-" + bracketed[1];

    // Drop everything that is not a digit, sign, or decimal point. This also
    // removes the thousands separators and any currency symbol.
    s = s.replace(/[^0-9.+-]/g, "");

    const n = Number(s);
    return Number.isFinite(n) ? n : 0;
}


/* ── Generic display helpers ──────────────────────────────────────
   Single source of truth for how dates and weeks are shown to users.
   These are DISPLAY-ONLY: they never feed values back to the backend,
   so business/data logic (formatDate, getISOWeek, getWeekNumber, …)
   stays untouched. Date  → "17 Jul 2026". Week → "14 Jul 2026 - 20 Jul 2026". */

const displayMonthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// "17 Jul 2026" from a Date, a "YYYY-MM-DD" string, or any parseable date.
// Returns "" for empty / invalid input.
export function formatDisplayDate(input) {
    if (input === null || input === undefined || input === "") return "";
    const d = input instanceof Date ? input : new Date(input);
    if (isNaN(d.getTime())) return "";
    return `${d.getDate()} ${displayMonthNames[d.getMonth()]} ${d.getFullYear()}`;
}

// "06 Sep 2026" — formatDisplayDate with a zero-padded day, for the reports rebuilt to the
// legacy layouts (T1.36: Account Balance Detail, P&L Summary). A stored "YYYY-MM-DD HH:MM:SS"
// is cut to its date part first, as displayStoredDate does. Returns "" for empty / invalid input.
export function formatPaddedDate(input) {
    if (input === null || input === undefined || input === "") return "";
    const str = String(input);
    // Only a "YYYY-MM-DD HH:MM:SS" timestamp is cut to its date part; "31 Aug 2026" is parsed whole.
    const d = input instanceof Date ? input
        : new Date(/^\d{4}-\d{2}-\d{2} /.test(str) ? str.split(" ")[0] : str);
    if (isNaN(d.getTime())) return "";
    return `${String(d.getDate()).padStart(2, "0")} ${displayMonthNames[d.getMonth()]} ${d.getFullYear()}`;
}

// "31 Aug 2026 - 06 Sep 2026" from a "YYYY-Www" week code — formatDisplayWeek, zero-padded (T1.36).
export function formatPaddedWeek(weekCode) {
    if (!weekCode) return "";
    const { start, end } = getISOWeekDates(normalizeWeekCode(weekCode));
    return `${formatPaddedDate(start)} - ${formatPaddedDate(end)}`;
}

// Display a stored "YYYY-MM-DD" or "YYYY-MM-DD HH:MM:SS" as "21 Oct 2026". Only the date part is
// parsed: a space-separated timestamp is not a valid Date string in every browser (Safari rejects
// it), and the date part is the same key the old grouped grids grouped on.
export function displayStoredDate(value) {
    if (value === null || value === undefined || value === "") return "";
    return formatDisplayDate(String(value).split(" ")[0]);
}

// Pad the week number so "2026-W8" and "2026-W08" both normalise to "2026-W08".
export function normalizeWeekCode(code) {
    if (!code) return "";
    const [year, week] = String(code).split("-W");
    if (year === undefined || week === undefined) return String(code);
    return `${year}-W${String(parseInt(week, 10)).padStart(2, "0")}`;
}

// "14 Jul 2026 - 20 Jul 2026" from a "YYYY-Www" week code.
export function formatDisplayWeek(weekCode) {
    if (!weekCode) return "";
    const { start, end } = getISOWeekDates(normalizeWeekCode(weekCode));
    return `${formatDisplayDate(start)} - ${formatDisplayDate(end)}`;
}


/* ── Device sale/purchase grid helpers ───────────────────────────
   Device sale/purchase records store their devices as a JSON array in
   PC_SH_SALE_ITEM / PUR_INV_ITEM / PC_WHS_ITEM. Each item carries
   ItemName (string or { value, label, display }), ItemIMEI, ItemDesc.
   These surface the device name / description / status for the grids,
   which previously read flat columns that device flows never set. */

function isJsonString(str) {
    try { JSON.parse(str); return true; } catch (e) { return false; }
}

// ItemName may be a plain string or a react-select { value, label, display } object.
function itemName(item) {
    const n = item && item.ItemName;
    if (n == null) return "";
    if (typeof n === "object") return n.display || n.label || n.value || "";
    return String(n);
}

// Tolerantly parse an invoice's stored items into an array.
export function parseInvoiceItems(raw) {
    if (Array.isArray(raw)) return raw;
    if (typeof raw === "string" && isJsonString(raw)) {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    }
    return [];
}

// Device name(s) in an invoice, e.g. "iPhone 12" or "iPhone 12 +2 more".
export function deviceLabel(raw) {
    const names = parseInvoiceItems(raw).map(itemName).filter(Boolean);
    if (names.length === 0) return "N/A";
    if (names.length === 1) return names[0];
    return `${names[0]} +${names.length - 1} more`;
}

// Joined device descriptions in an invoice.
export function deviceDescription(raw) {
    const descs = parseInvoiceItems(raw)
        .map(i => (i && i.ItemDesc ? String(i.ItemDesc) : "").trim())
        .filter(Boolean);
    return descs.length ? descs.join(", ") : "N/A";
}

// Transaction/payment status for a sale/purchase record: use a stored
// status when present, otherwise a sensible default for the record kind.
// "Phone Village Hanley (Shop)" — the counterparty of a sale or purchase, with its type, in the
// ONE format every sale/purchase grid uses (2026-10-22). Omits the brackets when there is no type,
// rather than printing "Name ()".
export function partyLabel(name, type) {
    const n = (name === null || name === undefined) ? "" : String(name).trim();
    const t = (type === null || type === undefined) ? "" : String(type).trim();
    if (!t) return n;
    return n ? `${n} (${t})` : `(${t})`;
}

export function transactionStatus(record, kind = "sale") {
    const stored = record && (record.SALE_STATUS || record.PUR_INV_STATUS);
    if (stored) return stored;
    return kind === "purchase" ? "Received" : "Complete";
}


/* ── Account-payment line helpers ─────────────────────────────────
   Lines inside pc_acc_payment.AP_DETAILS exist in two shapes, often mixed
   within the SAME array, so they must always be handled per line:

     legacy: { ShopPay_Shop: {label,value,type: shop|account|warehouse} }
     new:    { ShopPay_Acc:  {label,value,type:'shop'}   ← the paying shop
               ShopPay_Shop: {label,value,type: account|warehouse} | "" }

   Blank padding rows carry neither entity and must stay excluded. */

// True when a selector field actually holds a chosen entity (not "" / null).
export function isEntity(v) {
    return !!v && typeof v === "object"
        && (((v.label ?? "") !== "") || ((v.value ?? "") !== ""));
}

// A real payment line has an entity in either field; padding rows have neither.
export function isAccPayLine(line) {
    return !!line && (isEntity(line.ShopPay_Acc) || isEntity(line.ShopPay_Shop));
}

// Resolve one line into { shop, acc, wh } display labels across both shapes.
export function accPayEntities(line) {
    const out = { shop: "", acc: "", wh: "" };
    if (!line) return out;

    // New shape: the paying shop lives in ShopPay_Acc.
    const from = line.ShopPay_Acc;
    if (isEntity(from) && ((from.type ?? "shop") === "shop")) {
        out.shop = from.label ?? "";
    }

    // ShopPay_Shop is the TO entity (new) or the only entity (legacy).
    const to = line.ShopPay_Shop;
    if (isEntity(to)) {
        switch (to.type) {
            case "shop":
                if (out.shop === "") out.shop = to.label ?? "";   // legacy shop line
                break;
            case "account":
                out.acc = to.label ?? "";
                break;
            case "warehouse":
                out.wh = to.label ?? "";
                break;
            default:
                break;
        }
    }
    return out;
}


/* ── Report table layout ─────────────────────────────────────────────────────
 *
 * Reports are read and printed as flat tables, so a wide one is split into
 * stacked blocks instead of scrolling sideways.
 *
 * REPORT_MAX_COLUMNS counts EVERY column in a block, including the row-label
 * column (Week / Shop), which is repeated at the top of each block — without it
 * the rows in the second block could not be identified. So each block carries
 * REPORT_MAX_COLUMNS - 1 data columns.
 */
export const REPORT_MAX_COLUMNS = 12;

// [{start, end}] index ranges over the DATA columns, one per table block.
// Always returns at least one range so a report with no columns still renders
// its header and its "no data" state.
export function reportColumnChunks(dataColumnCount, maxColumns = REPORT_MAX_COLUMNS) {
    const perBlock = Math.max(1, maxColumns - 1);
    const total = Number(dataColumnCount) > 0 ? Number(dataColumnCount) : 0;
    const chunks = [];
    for (let start = 0; start < total; start += perBlock) {
        chunks.push({ start, end: Math.min(start + perBlock, total) });
    }
    return chunks.length ? chunks : [{ start: 0, end: 0 }];
}


/* ── Approval workflow (approve / request) ────────────────────────────
   Mirrors phone-clinic-services/helper/Approval.php. Keep the two in step:
   the server is the authority, this only decides which buttons to OFFER.

       PENDING  --request-->  REQUESTED  --approve-->  APPROVED
          ^                       |                        |
          +--------reject---------+                        |
          +---------------------reopen----------------------+                 */

export const APPROVAL_PENDING = 'PENDING';
export const APPROVAL_REQUESTED = 'REQUESTED';
export const APPROVAL_APPROVED = 'APPROVED';

// A row written before this feature existed has no status; treat it as PENDING
// rather than rendering an empty chip.
export function approvalStatus(value) {
    const s = String(value || '').trim().toUpperCase();
    return [APPROVAL_PENDING, APPROVAL_REQUESTED, APPROVAL_APPROVED].includes(s)
        ? s : APPROVAL_PENDING;
}

// Only a PENDING record may be edited or deleted — the lock the server enforces
// in pc_approval_lock_error(). Used to disable the buttons rather than let the
// user click into a 409.
// Is this role Super Admin? Same test the sidebar already uses in
// Layout/AdminLayout/index.js, kept in one place now that two features need it.
//
// This is for ENABLING UI only. The backend resolves the role from the signed
// JWT (helper/Approval.php pc_approval_role_code), so faking localStorage
// changes what the screen offers, never what the server accepts.
export function isSuperAdmin() {
    try {
        return localStorage.getItem('PC_USR_ROLE_ID') === '1'
            && localStorage.getItem('PC_GRP_ID') === '1';
    } catch (e) {
        return false;
    }
}

// Only a PENDING record may normally be edited or deleted.
//
// `canOverride` (2026-10-09) lets Super Admin through at any status, and the
// record KEEPS that status — an override is not sent back for re-approval.
// Callers pass isSuperAdmin(). Mirrors pc_approval_lock_check() on the server.
export function approvalIsEditable(value, canOverride = false) {
    if (canOverride) return true;
    return approvalStatus(value) === APPROVAL_PENDING;
}

/* Does the signed-in role hold `alias` on the screen at `menuUrl`?
 *
 * Reads the rights AdminLayout cached from PCGetUserMenu.php (which derives them
 * from pc_role_rights). Returns false when the cache is missing — hiding a
 * control is the safe failure, and the server refuses the call regardless.
 *
 * NOT a security boundary: approval is re-checked server-side on every call. */
export function hasAction(menuUrl, alias) {
    try {
        const raw = localStorage.getItem('PC_MENU_ACTIONS');
        if (!raw) return false;
        const map = JSON.parse(raw);
        const list = map && map[menuUrl];
        return Array.isArray(list) && list.includes(alias);
    } catch (e) {
        return false;
    }
}

/* The transitions to offer for a record, given the current status and whether
 * the user may approve. Returns [{ to, label, colour }].
 *
 * PENDING -> APPROVED is deliberately absent: the server refuses a one-step
 * approval, matching how the existing Weekly Sale button behaves. */
export function approvalActions(value, canApprove) {
    const s = approvalStatus(value);
    // `type` (2026-10-22) names the action for the grid's RowActions icon buttons. It is needed
    // because `to` alone is ambiguous — Reject and Reopen both go to PENDING. Additive: callers
    // that read only to / label / colour are unaffected.
    if (s === APPROVAL_PENDING) {
        return [{ to: APPROVAL_REQUESTED, label: 'Send for approval', colour: 'primary', type: 'request' }];
    }
    if (s === APPROVAL_REQUESTED) {
        return canApprove ? [
            { to: APPROVAL_APPROVED, label: 'Approve', colour: 'success', type: 'approve' },
            { to: APPROVAL_PENDING, label: 'Reject', colour: 'error', type: 'reject' },
        ] : [];
    }
    return canApprove ? [{ to: APPROVAL_PENDING, label: 'Reopen', colour: 'warning', type: 'reopen' }] : [];
}

/* Weeks holding not-approved financial records, keyed by week code (T1.35).
   `list` is a report endpoint's `unapprovedWeeks` ([{WEEK, WEEKLY_SALE, SHOP_PAYMENT,
   ACCOUNT_PAYMENT}], phone-clinic-services/helper/UnapprovedWeeks.php). Keys are normalised so
   "2026-W9" and "2026-W09" find the same entry. A marker for display only. */
export function unapprovedWeekMap(list) {
    const map = new Map();
    (Array.isArray(list) ? list : []).forEach(w => {
        if (w && w.WEEK) map.set(normalizeWeekCode(w.WEEK), w);
    });
    return map;
}
